// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class VoicemailOptInModel {
    static getAttributeTypeMap() {
        return VoicemailOptInModel.attributeTypeMap;
    }
}
VoicemailOptInModel.discriminator = undefined;
VoicemailOptInModel.additionalProperties = false;
VoicemailOptInModel.attributeTypeMap = [
    {
        "name": "phoneNumberId",
        "baseName": "phoneNumberId",
        "type": "number"
    },
    {
        "name": "isVmOptedIn",
        "baseName": "isVmOptedIn",
        "type": "boolean"
    },
];
//# sourceMappingURL=voicemailOptInModel.js.map